import axios from 'axios';

const DATAQUALITY_BASE_URL = process.env.REACT_APP_DATAQUALITY_API_URL || '/dataquality-proxy';

export interface PostalAddressSuggestion {
  label: string;
  score: number;
  housenumber: string | null;
  id: string;
  name: string;
  postcode: string;
  citycode: string;
  x: number;
  y: number;
  city: string;
  context: string;
  type: string;
  importance: number;
  street: string | null;
}

export interface PostalCheckResponse {
  query: string;
  address: {
    label: string;
    score: number;
    housenumber: string | null;
    id: string;
    name: string;
    postcode: string;
    citycode: string;
    city: string;
    context: string;
    type: string;
    importance: number;
    street: string | null;
    addressCompletionSuggestions: PostalAddressSuggestion[];
    longitude: number;
    latitude: number;
  };
}

export const checkPostalCode = async (address: string): Promise<PostalCheckResponse | null> => {
  try {
    const response = await axios.get<PostalCheckResponse>(
      `${DATAQUALITY_BASE_URL}/postal/check/${encodeURIComponent(address)}`
    );
    return response.data;
  } catch (error) {
    console.error('Erreur lors de la vérification du code postal:', error);
    return null;
  }
};
